export default __webpack_public_path__ + "static/media/handshake.f0e0be60.svg";